import { render, staticRenderFns } from "./ExperimentsAdd.vue?vue&type=template&id=1dfb593c&scoped=true&"
import script from "./ExperimentsAdd.vue?vue&type=script&lang=js&"
export * from "./ExperimentsAdd.vue?vue&type=script&lang=js&"
import style0 from "./ExperimentsAdd.vue?vue&type=style&index=0&id=1dfb593c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfb593c",
  null
  
)

export default component.exports